export const SHOW_EXTENDABLE_CARD = 'SHOW_EXTENDABLE_CARD'
export const HIDE_EXTENDABLE_CARD = 'HIDE_EXTENDABLE_CARD'

export const EXPAND_EXTENDABLE_CARD = 'EXPAND_EXTENDABLE_CARD'
export const COLLAPSE_EXTENDABLE_CARD = 'COLLAPSE_EXTENDABLE_CARD'

export const MOVE_EXTENDABLE_CARD = 'MOVE_EXTENDABLE_CARD'
